import React, { Component } from 'react';
import RecordBased from './RecordBased';
import Service from './Service';

import axios from 'axios';

class UdtDetails extends Component {
  state = {
    udtTypeName: null
  }

  constructor(props) {
    super(props);

    this.allUdtNames = props.allUdtNames

    this.state = {
      udtTypeName: props.typeName
    };
  } 

  load(tn) {
    if ( this.allUdtNames.includes(tn) ) {
      axios.get('assets/schemas/UDT-' + tn + '.json').then((response) => {
        console.log(response.data);
        this.setState({
          udtTypeName: tn,
          udt: response.data
        })       
      });
    }
  }

  componentDidMount() {
    if ( this.state.udtTypeName ) {
      this.load(this.state.udtTypeName)
    }
  }

  render() {
    if (this.state.udt) {

      let udt = this.state.udt;
      let ut = udt.Name.UdtType;

      if (ut === 'recordType' || 
          ut === 'keyType' || 
          ut === 'traitType' || 
          ut === 'unionType' || 
          ut === 'entityType' || 
          ut === 'enumType' ||
          ut === 'annotationType' ) {
        return (
          <div>
            <RecordBased udt={udt} udtDetailsComp={this} />
          </div>
        );
      }
      else if (ut === 'serviceType') {
        return (
          <div>
            <Service srv={udt} udtDetailsComp={this} />
          </div>
        )
      }
      else
      return (
        <div>
          {"Unknown UdtType " + ut}
        </div>
      );
    }
    else {
      return (
        <div>
          Loading {this.state.udtTypeName}...
          </div>
      );
    }

  }
}

export default UdtDetails;
